module.exports = __webpack_public_path__ + "img/transactions-report-empty.20c37618.png";